import agendaApiConfig from "./agendaApiConfig";
import ManageStorage from "src/shared/global/manageStorage";

const procedimientoService = {
  async getServicios(sue_correl) {
    let query = {
      sue_correl: sue_correl,
    };
    // Pasar sue_correl por query params !!!
    return await agendaApiConfig.get(`/agenda-servicio`, {
      params: {
        ...query,
      },
    });
  },
  async getProcedimientos(cod, sue_correl) {
    let query = {
      sue_correl: sue_correl,
    };

    // Pasar sue_correl por query params !!!
    return await agendaApiConfig.get(`/agenda-procedimiento/${cod}`, {
      params: {
        ...query,
      },
    });
  },
  async getExamenesProcedimientos(cod, sue_correl) {
    let query = {
      sue_correl: sue_correl,
    };

    // Pasar sue_correl por query params !!!
    return await agendaApiConfig.get(`/examenprocedimiento/${cod}`, {
      params: {
        ...query,
      },
    });
  },
};

export default procedimientoService;
